class CustomMarker extends google.maps.OverlayView {
    constructor(latLng, el, cache) {
        super();
        this._latLng = new google.maps.LatLng(latLng.lat, latLng.lng);
        this._el = el;
        this._cache = cache;
        this._point = null;
    }

    draw() {
        this.resetPos();
    }

    onAdd() {
        const panes = this.getPanes();
        panes.overlayImage.appendChild(this._el);
    }

    onRemove() {
        this.removeFromDOM();
        this.removeFromCache();
    }

    removeFromDOM() {
        if (this._el && this._el.parentNode) {
            this._el.parentNode.removeChild(this._el);
        }
    }

    getPosition() {
        return this._latLng;
    }

    resetPos(coord) {
        if (coord) {
            this._latLng = coord;
        }

        if (!this.map) {
            this.hide();
            return;
        }

        let point = this.getProjection().fromLatLngToDivPixel(this._latLng);

        if (point) {
            point = {x: Math.floor(point.x), y: Math.floor(point.y)};

            this.removeFromCache();
            this._cache.add(this.getLabel(point));
            this._point = point;
            this._el.style.left = `${point.x}px`;
            this._el.style.top = `${point.y}px`;

            this.show();
        }
    }

    getLabel(point) {
        return point ? `${point.x}|${point.y}` : '';
    }

    isPointsNearly(p1, p2) {
        const gap = 20; // magic number extracted from some practical playing with google coordinates computation logic
        return (Math.abs(p1.x - p2.x) < gap) && (Math.abs(p1.y - p2.y) < gap);
    }

    removeFromCache() {
        if (this._point) {
            this._cache.delete(this.getLabel(this._point));
        }
    }

    getMaxZIndex() {
        return google.maps.Marker.MAX_ZINDEX;
    }

    hide() {
        if (this._el) {
            this._el.style.visibility = 'hidden';
        }
    }

    show() {
        if (this._el) {
            this._el.style.visibility = 'visible';
        }
    }
}

function initMapMakerComponent(app) {
    app.component('map-marker', {
        template: '#map-marker',
        props: {
            map: {},
            redrawNeeded: {},
            cache: {},
            markerInfo: {},
        },
        data() {
            return {
                marker: null,
            };
        },
        beforeUnmount() {
            if (this.marker) {
                this.marker.removeFromCache();
            }
        },
        watch: {
            redrawNeeded(val) {
                if (val > 0) {
                    const latLng = {lat: this.markerInfo.latitude, lng: this.markerInfo.longitude};

                    this.marker = new CustomMarker(latLng, this.$el, this.cache);
                }
            },
            'markerInfo.listing.mouseOver'(val) {
                this.focusMarker(val);
            },
        },

        methods: {
            focusMarker(focus) {
                if (this.$el.parentElement) {
                    this.$el.parentElement.style.zIndex = focus && this.marker ? this.marker.getMaxZIndex() : 0;
                }
            },
        },
    });
}

export default initMapMakerComponent;
